export default {
  queryPermission: '/auth/userPermission/frontDeskQueryPermission', 
  queryUserList:'/auth/user/frontDeskQueryUser',  
};


// WEBPACK FOOTER //
// ./src/api/authQuery.js